/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LandlordSlaContractDto
 */
export interface LandlordSlaContractDto {
    /**
     * 
     * @type {string}
     * @memberof LandlordSlaContractDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof LandlordSlaContractDto
     */
    uptimeTargetPct?: number | null;
    /**
     * DC response time in days
     * @type {number}
     * @memberof LandlordSlaContractDto
     */
    responseDcDays: number;
    /**
     * AC response time in days
     * @type {number}
     * @memberof LandlordSlaContractDto
     */
    responseAcDays: number;
    /**
     * 
     * @type {number}
     * @memberof LandlordSlaContractDto
     */
    penaltyPerDayAmount: number;
    /**
     * 
     * @type {string}
     * @memberof LandlordSlaContractDto
     */
    penaltyCurrency: string;
    /**
     * 
     * @type {string}
     * @memberof LandlordSlaContractDto
     */
    paymentModel: LandlordSlaContractDtoPaymentModelEnum;
    /**
     * 
     * @type {Date}
     * @memberof LandlordSlaContractDto
     */
    validFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof LandlordSlaContractDto
     */
    validTo?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof LandlordSlaContractDto
     */
    status: LandlordSlaContractDtoStatusEnum;
}


/**
 * @export
 */
export const LandlordSlaContractDtoPaymentModelEnum = {
    Annual: 'ANNUAL',
    Monthly: 'MONTHLY',
    PerCp: 'PER_CP'
} as const;
export type LandlordSlaContractDtoPaymentModelEnum = typeof LandlordSlaContractDtoPaymentModelEnum[keyof typeof LandlordSlaContractDtoPaymentModelEnum];

/**
 * @export
 */
export const LandlordSlaContractDtoStatusEnum = {
    Draft: 'DRAFT',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Expired: 'EXPIRED'
} as const;
export type LandlordSlaContractDtoStatusEnum = typeof LandlordSlaContractDtoStatusEnum[keyof typeof LandlordSlaContractDtoStatusEnum];


/**
 * Check if a given object implements the LandlordSlaContractDto interface.
 */
export function instanceOfLandlordSlaContractDto(value: object): value is LandlordSlaContractDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('responseDcDays' in value) || value['responseDcDays'] === undefined) return false;
    if (!('responseAcDays' in value) || value['responseAcDays'] === undefined) return false;
    if (!('penaltyPerDayAmount' in value) || value['penaltyPerDayAmount'] === undefined) return false;
    if (!('penaltyCurrency' in value) || value['penaltyCurrency'] === undefined) return false;
    if (!('paymentModel' in value) || value['paymentModel'] === undefined) return false;
    if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function LandlordSlaContractDtoFromJSON(json: any): LandlordSlaContractDto {
    return LandlordSlaContractDtoFromJSONTyped(json, false);
}

export function LandlordSlaContractDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LandlordSlaContractDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'uptimeTargetPct': json['uptimeTargetPct'] == null ? undefined : json['uptimeTargetPct'],
        'responseDcDays': json['responseDcDays'],
        'responseAcDays': json['responseAcDays'],
        'penaltyPerDayAmount': json['penaltyPerDayAmount'],
        'penaltyCurrency': json['penaltyCurrency'],
        'paymentModel': json['paymentModel'],
        'validFrom': (new Date(json['validFrom'])),
        'validTo': json['validTo'] == null ? undefined : (new Date(json['validTo'])),
        'status': json['status'],
    };
}

export function LandlordSlaContractDtoToJSON(json: any): LandlordSlaContractDto {
    return LandlordSlaContractDtoToJSONTyped(json, false);
}

export function LandlordSlaContractDtoToJSONTyped(value?: LandlordSlaContractDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'uptimeTargetPct': value['uptimeTargetPct'],
        'responseDcDays': value['responseDcDays'],
        'responseAcDays': value['responseAcDays'],
        'penaltyPerDayAmount': value['penaltyPerDayAmount'],
        'penaltyCurrency': value['penaltyCurrency'],
        'paymentModel': value['paymentModel'],
        'validFrom': value['validFrom'].toISOString(),
        'validTo': value['validTo'] == null ? value['validTo'] : value['validTo'].toISOString(),
        'status': value['status'],
    };
}

